import blogCardMini from "./blogCardMini"
export default blogCardMini;
